const loadFont = (fontName, fontUrl, fontWeight, fontDisplay = 'swap') => {
  const fontFace = new FontFace(fontName, `url(${fontUrl})`, {
    weight: fontWeight,
    display: fontDisplay,
  })

  return fontFace.load().then(loadedFont => {
    document.fonts.add(loadedFont)
    return loadedFont
  })
}

export const loadNonCriticalFonts = () => {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => {
      Promise.all([
        loadFont(
          'Raleway',
          new URL('../assets/fonts/Raleway-SemiBold.ttf', import.meta.url).href,
          '600',
          'swap'
        ),
        loadFont(
          'Raleway',
          new URL('../assets/fonts/Raleway-Bold.ttf', import.meta.url).href,
          '700',
          'optional'
        ),
        loadFont(
          'Raleway',
          new URL('../assets/fonts/Raleway-Black.ttf', import.meta.url).href,
          '900',
          'optional'
        ),
      ]).catch(error => {
        // eslint-disable-next-line no-console
        console.warn('Non-critical fonts failed to load:', error)
      })
    })
  } else {
    setTimeout(() => {
      Promise.all([
        loadFont(
          'Raleway',
          new URL('../assets/fonts/Raleway-SemiBold.ttf', import.meta.url).href,
          '600',
          'swap'
        ),
        loadFont(
          'Raleway',
          new URL('../assets/fonts/Raleway-Bold.ttf', import.meta.url).href,
          '700',
          'optional'
        ),
        loadFont(
          'Raleway',
          new URL('../assets/fonts/Raleway-Black.ttf', import.meta.url).href,
          '900',
          'optional'
        ),
      ]).catch(error => {
        // eslint-disable-next-line no-console
        console.warn('Non-critical fonts failed to load:', error)
      })
    }, 1000)
  }
}
